<template>
  <details
    v-if="summary"
    class="ghl-conversion-sync"
    @toggle="open = $event.target.open"
  >
    <summary>
      GHL conversion sync ·
      {{ summary.enabled ? 'Scheduled every 15 minutes' : 'Not activated' }}
    </summary>
    <div v-if="open">
      <p>
        Add the exact tag <b>converted</b> to a GHL contact when they hire you.
        No other tag, opportunity stage or custom field marks a conversion.
      </p>
      <p>
        Checks leads from the last {{ summary.recent_days }} days, with a
        nightly sweep of older leads. Large accounts are processed in batches.
        Latest successful check:
        {{ summary.last_successful_at || 'Not checked yet' }} UTC.
      </p>
      <p v-if="summary.counts.read_failed" role="alert">
        {{ summary.counts.read_failed }} lead checks failed. Check the GHL
        connection and contact read access. Existing outcomes are retained.
      </p>
      <p v-if="summary.counts.no_match">
        {{ summary.counts.no_match }} leads have no unambiguous contact
        suggestion yet.
      </p>
      <p v-if="error" role="alert">{{ error }}</p>
      <ul>
        <li v-for="row in summary.review.data" :key="row.id">
          Lead #{{ row.lead_id }} · {{ statusLabel(row.status) }}
          <template v-if="row.suggested_contact_id || row.contact_id">
            · GHL contact {{ row.suggested_contact_id || row.contact_id }}
            <button
              v-if="row.status !== 'read_failed'"
              :disabled="busy"
              @click="confirm(row)"
            >
              Confirm this lead is the originating inquiry
            </button>
          </template>
        </li>
      </ul>
      <button :disabled="busy" @click="load(summary.review.current_page)">
        Refresh
      </button>
      <button
        v-if="summary.review.current_page > 1"
        @click="load(summary.review.current_page - 1)"
      >
        Previous
      </button>
      <button
        v-if="summary.review.current_page < summary.review.last_page"
        @click="load(summary.review.current_page + 1)"
      >
        Next
      </button>
      <p>
        Confirm suggested matches only after checking the contact in GHL.
        Repeated inquiries are not counted as several conversions from one tag.
      </p>
    </div>
  </details>
</template>
<script>
import axios from 'axios'
export default {
  data() {
    return { summary: null, busy: false, error: '', open: false }
  },
  mounted() {
    this.load()
  },
  methods: {
    options() {
      return {
        headers: { Authorization: 'Bearer ' + this.$store.state.auth.jwt },
      }
    },
    statusLabel(status) {
      return (
        {
          needs_match: 'Suggested match needs confirmation',
          ambiguous: 'Repeated contact needs attribution review',
          read_failed: 'Contact read failed',
        }[status] || status
      )
    },
    async load(page = 1) {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_ENDPOINT}/call-tracking/outcomes/ghl-sync?page=${page}`,
          this.options()
        )
        this.summary = data
      } catch (e) {
        if (this.summary) this.error = 'Could not refresh GHL sync status.'
      }
    },
    async confirm(row) {
      this.busy = true
      this.error = ''
      try {
        await axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}/call-tracking/outcomes/ghl-sync/${row.id}/confirm`,
          { contact_id: row.suggested_contact_id || row.contact_id },
          this.options()
        )
        await this.load()
      } catch (e) {
        this.error =
          (e.response && e.response.data.message) ||
          'Could not confirm this match.'
      } finally {
        this.busy = false
      }
    },
  },
}
</script>
<style scoped>
.ghl-conversion-sync {
  background: #f3f8fb;
  border: 1px solid #dce5eb;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 20px;
  font-size: 13px;
  color: #33465a;
}
summary {
  cursor: pointer;
  font-weight: 700;
}
p,
li {
  margin: 12px 0;
  line-height: 1.6;
  overflow-wrap: anywhere;
}
button {
  padding: 6px 12px;
  border: 1px solid #9ab9c5;
  border-radius: 6px;
  margin: 4px;
  background: white;
}
</style>
